export const CLIENTS_FILTER_KEY_SEARCH = 'searchString';
export const CLIENTS_FILTER_KEY_MANAGER = 'manager';
export const CLIENTS_FILTER_KEY_STATUS = 'status';

export const CLIENTS_TABLE_FILTER_KEYS = [
  CLIENTS_FILTER_KEY_SEARCH,
  CLIENTS_FILTER_KEY_MANAGER,
  CLIENTS_FILTER_KEY_STATUS,
];

export const CLIENTS_TABLE_FILTERS_STORAGE_KEY = 'clients-table-filters';
